window.PerfyraLocationData = {
  AE: {
    name: { en: "United Arab Emirates", ar: "الإمارات العربية المتحدة" },
    countryCode: "AE",
    dialCode: "+971",
    flag: "🇦🇪",
    cities: {
      "Abu Dhabi": {
        label: { en: "Abu Dhabi", ar: "أبوظبي" },
        areas: ["Al Reem Island", "Al Raha", "Khalifa City", "Mussafah", "Saadiyat Island", "Yas Island", "Downtown Abu Dhabi", "Corniche"]
      },
      Dubai: {
        label: { en: "Dubai", ar: "دبي" },
        areas: ["Downtown Dubai", "Dubai Marina", "Jumeirah", "Business Bay", "Deira", "Bur Dubai", "JLT", "Palm Jumeirah", "Al Barsha", "Mirdif"]
      },
      Sharjah: {
        label: { en: "Sharjah", ar: "الشارقة" },
        areas: ["Al Majaz", "Al Nahda", "Muwaileh", "University City", "Al Khan"]
      },
      Ajman: {
        label: { en: "Ajman", ar: "عجمان" },
        areas: ["Ajman Downtown", "Al Nuaimiya", "Al Rawda", "Al Jurf"]
      },
      "Ras Al Khaimah": {
        label: { en: "Ras Al Khaimah", ar: "رأس الخيمة" },
        areas: ["Al Nakheel", "Al Hamra", "Julphar", "Al Qusaidat"]
      },
      Fujairah: {
        label: { en: "Fujairah", ar: "الفجيرة" },
        areas: ["Fujairah City", "Sakamkam", "Mirbah"]
      },
      "Umm Al Quwain": {
        label: { en: "Umm Al Quwain", ar: "أم القيوين" },
        areas: ["UAQ City", "Al Raas", "Falaj Al Mualla"]
      }
    }
  },
  SA: {
    name: { en: "Saudi Arabia", ar: "المملكة العربية السعودية" },
    countryCode: "SA",
    dialCode: "+966",
    flag: "🇸🇦",
    cities: {
      Riyadh: {
        label: { en: "Riyadh", ar: "الرياض" },
        areas: ["Olaya", "Al Malaz", "Al Nakheel", "Diplomatic Quarter", "Al Yasmin", "Al Sulimaniyah"]
      },
      Jeddah: {
        label: { en: "Jeddah", ar: "جدة" },
        areas: ["Al Balad", "Corniche", "Al Rawdah", "Obhur", "Al Zahra", "Al Hamra"]
      },
      Dammam: {
        label: { en: "Dammam", ar: "الدمام" },
        areas: ["Al Faisaliyah", "Al Shati", "Al Jalawiyah", "Corniche"]
      },
      Makkah: {
        label: { en: "Makkah", ar: "مكة المكرمة" },
        areas: ["Al Aziziyah", "Ajyad", "Al Shawqiyah", "Al Nuzha"]
      },
      Madinah: {
        label: { en: "Madinah", ar: "المدينة المنورة" },
        areas: ["Quba", "Al Haram", "Uhud", "Al Aziziyah"]
      },
      Khobar: {
        label: { en: "Khobar", ar: "الخبر" },
        areas: ["Corniche", "Al Thuqbah", "Al Ulaya", "Al Bandariyah"]
      }
    }
  },
  KW: {
    name: { en: "Kuwait", ar: "الكويت" },
    countryCode: "KW",
    dialCode: "+965",
    flag: "🇰🇼",
    cities: {
      "Kuwait City": {
        label: { en: "Kuwait City", ar: "مدينة الكويت" },
        areas: ["Sharq", "Mirgab", "Dasman", "Qibla"]
      },
      Hawalli: {
        label: { en: "Hawalli", ar: "حولي" },
        areas: ["Salmiya", "Jabriya", "Bayan", "Mishref"]
      },
      "Al Ahmadi": {
        label: { en: "Al Ahmadi", ar: "الأحمدي" },
        areas: ["Fahaheel", "Mangaf", "Mahboula", "Abu Halifa"]
      },
      Jahra: {
        label: { en: "Jahra", ar: "الجهراء" },
        areas: ["Jahra City", "Qairawan", "Naeem"]
      },
      "Farwaniya": {
        label: { en: "Farwaniya", ar: "الفروانية" },
        areas: ["Farwaniya", "Khaitan", "Jleeb Al-Shuyoukh", "Ardiya"]
      }
    }
  },
  QA: {
    name: { en: "Qatar", ar: "قطر" },
    countryCode: "QA",
    dialCode: "+974",
    flag: "🇶🇦",
    cities: {
      Doha: {
        label: { en: "Doha", ar: "الدوحة" },
        areas: ["West Bay", "The Pearl", "Lusail", "Al Sadd", "Old Airport", "Al Rayyan"]
      },
      "Al Wakrah": {
        label: { en: "Al Wakrah", ar: "الوكرة" },
        areas: ["Al Wakrah City", "Al Wukair", "Mesaieed"]
      },
      "Al Khor": {
        label: { en: "Al Khor", ar: "الخور" },
        areas: ["Al Khor City", "Al Thakhira"]
      },
      "Umm Salal": {
        label: { en: "Umm Salal", ar: "أم صلال" },
        areas: ["Umm Salal Mohammed", "Umm Salal Ali"]
      }
    }
  },
  BH: {
    name: { en: "Bahrain", ar: "البحرين" },
    countryCode: "BH",
    dialCode: "+973",
    flag: "🇧🇭",
    cities: {
      Manama: {
        label: { en: "Manama", ar: "المنامة" },
        areas: ["Diplomatic Area", "Juffair", "Seef", "Adliya", "Gudaibiya"]
      },
      Muharraq: {
        label: { en: "Muharraq", ar: "المحرق" },
        areas: ["Muharraq Town", "Busaiteen", "Hidd"]
      },
      Riffa: {
        label: { en: "Riffa", ar: "الرفاع" },
        areas: ["East Riffa", "West Riffa", "Bu Quwah"]
      },
      "Isa Town": {
        label: { en: "Isa Town", ar: "مدينة عيسى" },
        areas: ["Isa Town Center", "Zayed Town"]
      }
    }
  },
  OM: {
    name: { en: "Oman", ar: "عُمان" },
    countryCode: "OM",
    dialCode: "+968",
    flag: "🇴🇲",
    cities: {
      Muscat: {
        label: { en: "Muscat", ar: "مسقط" },
        areas: ["Qurum", "Al Khuwair", "Ruwi", "Muttrah", "Al Azaiba", "Seeb"]
      },
      Salalah: {
        label: { en: "Salalah", ar: "صلالة" },
        areas: ["Salalah Center", "Awqad", "Al Hafah"]
      },
      Sohar: {
        label: { en: "Sohar", ar: "صحار" },
        areas: ["Sohar City", "Al Hambar", "Liwa"]
      },
      Nizwa: {
        label: { en: "Nizwa", ar: "نزوى" },
        areas: ["Nizwa City", "Birkat Al Mouz"]
      }
    }
  },
  JO: {
    name: { en: "Jordan", ar: "الأردن" },
    countryCode: "JO",
    dialCode: "+962",
    flag: "🇯🇴",
    cities: {
      Amman: {
        label: { en: "Amman", ar: "عمّان" },
        areas: ["Abdoun", "Jabal Amman", "Khalda", "Sweifieh", "Abdali", "University Street"]
      },
      Irbid: {
        label: { en: "Irbid", ar: "إربد" },
        areas: ["Irbid City", "Al Husn", "Al Mazar"]
      },
      Zarqa: {
        label: { en: "Zarqa", ar: "الزرقاء" },
        areas: ["Zarqa City", "Russeifa", "New Zarqa"]
      },
      Aqaba: {
        label: { en: "Aqaba", ar: "العقبة" },
        areas: ["Aqaba City", "Tala Bay", "Southern Beach"]
      }
    }
  }
};
